import apiClient from '../lib/apiClient';

const notificationService = {
  getNotifications: async (filters = {}) => {
    try {
      const result = await apiClient.get('/notifications', filters);
      if (result.success) return result;
      return { success: true, data: [] };
    } catch (error) {
      return { success: true, data: [] };
    }
  },

  markRead: async (notificationId) => {
    try {
      return await apiClient.post(`/notifications/${notificationId}/read`, {});
    } catch (error) {
      return { success: false, error: error.message || 'Failed to mark notification read' };
    }
  },

  markAllRead: async (employeeId) => {
    try {
      return await apiClient.post('/notifications/markAllRead', { employee_id: employeeId });
    } catch (error) {
      return { success: false, error: error.message || 'Failed to mark notifications read' };
    }
  },

  getPreferences: async (employeeId) => {
    try {
      const result = await apiClient.get('/notifications/preferences', { employee_id: employeeId });
      if (result.success) return result;
      return {
        success: true,
        data: {
          employee_id: employeeId,
          in_app: 1,
          email: 0,
          sms: 0,
          attendance_alerts: 1,
          payroll_alerts: 1,
          leave_updates: 1,
        },
      };
    } catch (error) {
      return {
        success: true,
        data: {
          employee_id: employeeId,
          in_app: 1,
          email: 0,
          sms: 0,
          attendance_alerts: 1,
          payroll_alerts: 1,
          leave_updates: 1,
        },
      };
    }
  },

  updatePreferences: async (employeeId, prefs) => {
    try {
      return await apiClient.put('/notifications/preferences', {
        employee_id: employeeId,
        ...prefs
      });
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update preferences' };
    }
  }
};

export default notificationService;
